(function () {
  // ---- CONFIG ----
  var REDIRECT_URL = "https://www.go-parts.com.au/collections/mac-lifter-kit/Mac-Lifter-Kit";

  var TARGET_COUNTRIES = [
    "BN", "KH", "ID", "LA", "MY", "MM", "SG", "TH", "TL", "VN",
    "AU", "NZ",
    "JP", "KR", "HK", "CN"
  ];

  // ---- GUARDS ----

  // Shopify country check (⚠️ still not super reliable)
  if (!window.Shopify || !Shopify.country) return;

  // Prevent redirect loop
  if (window.location.hostname.includes("go-parts.com.au")) return;

  // Skip Shopify theme editor
  if (window.Shopify && Shopify.designMode) return;

  // Skip checkout/cart (VERY IMPORTANT)
  if (
    window.location.pathname.includes("/cart") ||
    window.location.pathname.includes("/checkout")
  ) return;

  // Skip bots (SEO protection)
  var ua = navigator.userAgent.toLowerCase();
  if (
    ua.includes("googlebot") ||
    ua.includes("bingbot") ||
    ua.includes("yandex") ||
    ua.includes("duckduckbot")
  ) return;

  // ---- LOGIC ----
  if (TARGET_COUNTRIES.indexOf(Shopify.country) !== -1) {
    window.location.replace(REDIRECT_URL);
  }
})();